import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { computed } from 'mobx';
import { observer } from 'mobx-react';
import { withStyles } from 'material-ui/styles';

import List from 'material-ui/List';
import Collapse from 'material-ui/transitions/Collapse';
import TreeNode from 'components/TreeNode';

import TreeNodeModel from 'models/TreeNode';
import withAppStore from 'decorators/withAppStore';

import styles from 'styles/components/TreeList';
import BottomLine from './BottomLine';

class TreeList extends Component {

  static propTypes = {
    nodes: PropTypes.arrayOf(PropTypes.instanceOf(TreeNodeModel)).isRequired,
    nested: PropTypes.bool
  }

  static defaultProps = {
    nested: false
  }

  @computed
  get dense() {
    return this.appStore.dense;
  }

  render() {
    const { nodes, nested, classes } = this.props;

    return (
      <List
        disablePadding
        className={ classnames({ [classes.nested]: nested }) }
        dense={ this.dense }
      >
        { nodes.map((node, index) => (
          <Fragment key={ index }>
            <TreeNode node={ node } />
            <Collapse
              component="li"
              in={ node.isExpanded }
              timeout="auto"
              unmountOnExit
            >
              <EnchantedTreeList
                nodes={ node.children }
                nested={ true }
              />
            </Collapse>
          </Fragment>
        ))}
        <BottomLine/>
      </List>
    );
  }

}

@withStyles(styles)
@withAppStore
@observer
export default class EnchantedTreeList extends TreeList {}





// WEBPACK FOOTER //
// ./src/components/TreeList.js